import httpClient from '../../utils/httpClient';
import { ApiSuccessResponse } from '../../utils/apiSchemas';
import { ContactEnum } from '../../utils/ContactEnum';

// Base route for Landing Page endpoints
const LANDING_BASE_ROUTE = '/api/v1/portal/landing-page';

export interface LandingContactPayload {
  name: string;
  email: string;
  companyName: string;
  description: string;
  contactType: ContactEnum;
}

export type LandingContactResponse = LandingContactPayload;

export const postLandingContact = async (
  payload: LandingContactPayload
): Promise<ApiSuccessResponse<LandingContactResponse>> => {
  const response = await httpClient.post<ApiSuccessResponse<LandingContactResponse>>(
    `${LANDING_BASE_ROUTE}/notificate-to-contact`,
    payload
  );
  return response.data;
};

export const getFeebowMediaKit = async (language: string = 'en-US'): Promise<ApiSuccessResponse<string>> => {
  const response = await httpClient.get<ApiSuccessResponse<string>>(
    `${LANDING_BASE_ROUTE}/get-feebow-midia-kit`,
    {
      headers: {
        'Accept-Language': language
      }
    }
  );
  return response.data;
};

export const getImmigrationCanadaMediaKit = async (language: string = 'en-US'): Promise<ApiSuccessResponse<string>> => {
  const response = await httpClient.get<ApiSuccessResponse<string>>(
    `${LANDING_BASE_ROUTE}/get-immigration-canada-midia-kit`,
    {
      headers: {
        'Accept-Language': language
      }
    }
  );
  return response.data;
};